import { useEffect } from 'react';
import translation from '../../languages';
import SharedModal from '../shared-modal/shared-modal';
import { ReactComponent as WorldIcon } from './assets/world.svg';
import { trackPopupInteraction, wasShown7DaysAgo } from './new-worlds-launch-modal.utils';

type NewWorldsModalWrapperProps = {
    close: () => void;
    confirm: () => void;
    usersCountryCode: string;
} & TranslationProps;

const NewWorldsModalWrapper = ({ usersCountryCode, close, confirm, t }: NewWorldsModalWrapperProps) => {
    useEffect(() => {
        trackPopupInteraction('popupShown');

        if (wasShown7DaysAgo()) {
            trackPopupInteraction('popupShownAfter7Days');
        }
    }, []);

    const country = t(`common.worlds.${usersCountryCode}.name`);
    const btnConfig = [
        {
            action: close,
            className: 'styled transparent',
            text: t('modals.newWorldsLaunchModal.stayBtn')
        },
        {
            action: confirm,
            className: 'confirm-new-world styled yellow',
            disabled: false,
            text: t('modals.newWorldsLaunchModal.continueBtn')
        }
    ];

    return (
        <SharedModal
            body={
                <div className='body-wrapper'>
                    {usersCountryCode && (
                        <div className='title'>{t('modals.newWorldsLaunchModal.title', { country })}</div>
                    )}
                    <div className='body'>{t('modals.newWorldsLaunchModal.subTitle', { country })}</div>
                </div>
            }
            btnConfig={btnConfig}
            dialogClassName='new-worlds-launch-modal'
            title={<WorldIcon />}
            onClose={close}
        />
    );
};

const translate = translation(['modals', 'common']);

export default translate(NewWorldsModalWrapper);
